import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();
const isBricoStore = websiteName === "bricostore";

const SellerInfo = ({
  seller: {
    name,
    company_cui,
    company_name,
    address,
    phone,
    email,
    company_fiscal_number,
  },
}) => (
  <section>
    <h1
      className={
        isBricoStore
          ? "bd-display3"
          : "text-2xl font-medium leading-31.2 md:text-[34px]"
      }
    >
      {name}
    </h1>

    <div className="leading-6 my-6">
      {company_name && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">
            Denumire:
          </span>

          <span>{company_name}</span>
        </div>
      )}

      {address && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">
            Adresa:
          </span>
          <span>{address}</span>
        </div>
      )}

      {company_cui && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">CUI:</span>
          <span>{company_cui}</span>
        </div>
      )}

      {company_fiscal_number && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">
            Nr.Inreg.Reg.Com.:
          </span>{" "}
          <span>{company_fiscal_number}</span>
        </div>
      )}

      {phone && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">
            Telefon:
          </span>
          <span>{phone}</span>
        </div>
      )}

      {email && (
        <div className="flex">
          <span className="min-w-[30%] md:min-w-[15%] font-medium">Email:</span>
          <span>{email}</span>
        </div>
      )}
    </div>
  </section>
);

export default SellerInfo;
